
import Innerbannerlines from "@/../../public/images/inner-banner-lines.svg";
import Logoicon from "@/../../public/images/fav-icon.svg";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { aboutApi } from "../service/apis/pages.api";
import Loader from "../common/Loader/loader";

const AboutScreen = () => {
    const navigate = useNavigate();
    const [responseData, setResponseData] = useState<any>([]);
    const [titleSlug, setTitleSlug] = useState<any>(null);
    const [ , setIsLoading] = useState(false);

    const aboutContents = async() => {
        setIsLoading(true);
        try {
            const response = await aboutApi();
            //console.log(response);
            setResponseData(response?.pageData?.pageContent);
            setTitleSlug(response?.pageData);
        } catch (error) {
            console.error("Catch Error: ", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        aboutContents();
    }, []);
    //console.log(titleSlug);
    console.log("responseData",responseData);

    const value_texts = responseData[5]?.formFieldRepeater;

    const decodeHtml = (html ="") => {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    }; 

    const sanitizeData = (htmldata = "") => {
        const sanitizedDescription = decodeHtml(htmldata);
        return (
          <div dangerouslySetInnerHTML={{ __html: sanitizedDescription }}></div>
        );
    };

    return (
        <>
            <div className="front-pages">

                <section className="home-banner innerBanner position-relative common-padd-xl">
                    <div className="homeLine"><img src={Innerbannerlines} alt="line icon" /></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="innerBanner-info text-center">
                                    {titleSlug && (
                                        <h1>{titleSlug?.title}</h1>
                                    )}
                                    <div className="breadcrumb-holder text-center">
                                        <Breadcrumb>
                                            <Breadcrumb.Item onClick={() => navigate('/')}><img src={Logoicon} alt="logo icon" />Home</Breadcrumb.Item>
                                            <Breadcrumb.Item active>{titleSlug?.title}</Breadcrumb.Item>
                                        </Breadcrumb>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="aboutpagetop-area position-relative">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 order-2">
                                <div className="aboutpagetop-info">
                                    {/* <p>Welcome to Pelorus Group, your trusted partner in connecting businesses with exceptional temporary foreign workers in Canada. With a deep understanding of the unique challenges and opportunities in the recruitment landscape, we specialize in bridging the gap between employers and skilled talent from around the globe.</p>
                                    <p>At Pelorus Group, we are committed to excellence and integrity in our services. Our team of experienced professionals works closely with both employers and candidates, ensuring a seamless and efficient placement process. We prioritize finding the right fit for your business needs while supporting workers in their pursuit of new opportunities in Canada.</p>
                                    <p>Our extensive network and thorough vetting process enable us to match employers with qualified candidates who bring diverse skills and perspectives to their teams. We believe in fostering lasting partnerships and contributing to the success of both businesses and workers.</p>
                                    <p>Choose Pelorus Group for your recruitment needs and let us help you navigate the complexities of temporary foreign worker placement in Canada. Together, we can build a brighter future for your workforce.</p> */}
                                    {responseData[3]?.type === "editor" && responseData[3]?.content && (
                                        sanitizeData(responseData[3]?.content)
                                    )}
                                </div>
                            </div>
                            <div className="col-lg-6 bundle-flex-left">
                                <div className="bundleImg-holder">
                                    <div className="row align-items-end mb-4">
                                        <div className="col-lg-6">
                                            {responseData[0]?.type === "image" && responseData[0]?.content && (
                                                <div className="galleryImg1">
                                                    <img src={responseData[0]?.content} alt="img 1" />
                                                </div>
                                            )}
                                        </div>
                                        <div className="col-lg-6">
                                            {responseData[1]?.type === "image" && responseData[1]?.content && (
                                                <div className="galleryImg2">
                                                    <img src={responseData[1]?.content} alt="img 2" />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12">
                                            {responseData[2]?.type === "image" && responseData[2]?.content && (
                                                <div className="galleryImg3">
                                                    <img src={responseData[2]?.content} alt="img 3" />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="corevalues-area abtPage common-padd-xl">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 text-center">
                                {responseData[4]?.type === "text" && responseData[4]?.content && (
                                    // <h2><span>Core</span> Values</h2>
                                    <h2>{sanitizeData(responseData[4]?.content)}</h2>
                                )}
                            </div>
                        </div>
                        <div className="row">
                            {value_texts ? ( value_texts.map((values: any, index: any) => (
                                <div key={index} className="col-lg-4">
                                    <div className="corevaluesCard">
                                        {values[0]?.type === "image" && values[0]?.content && (
                                            <div className="categoryIcon">
                                                <img src={values[0]?.content} alt={values[1]?.content} />
                                            </div>
                                        )}
                                        {values[1]?.type === "text" && values[1]?.content && (
                                            <h4>{values[1]?.content}</h4>
                                        )}
                                        {values[2]?.type === "textarea" && values[2]?.content && (
                                            <p>{values[2]?.content}</p>
                                        )}
                                    </div>
                                </div>
                                ))
                            ) : (
                                <Loader/>
                            )}

                            {/* <div className="col-lg-4">
                                <div className="corevaluesCard">
                                    <div className="categoryIcon"><img src={Core2} alt="icon" /></div>
                                    <h4>Ethical Responsibility</h4>
                                    <p>Commit to fair labor practices, protecting the rights of foreign workers, and adhering strictly to immigration and labor laws.</p>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="corevaluesCard">
                                    <div className="categoryIcon"><img src={Core3} alt="icon" /></div>
                                    <h4>Accountability</h4>
                                    <p>Take responsibility for providing quality placements and resolving any issues that arise for both employers and employees.</p>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="corevaluesCard">
                                    <div className="categoryIcon"><img src={Core4} alt="icon" /></div>
                                    <h4>Commitment to Quality</h4>
                                    <p>Strive for high standards in matching qualified, skilled workers to jobs that fit their skills and career goals, supporting both client needs and employee success.</p>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="corevaluesCard">
                                    <div className="categoryIcon"><img src={Core5} alt="icon" /></div>
                                    <h4>Compliance and Legal Integrity</h4>
                                    <p>Adhere to all regulations and legal requirements, ensuring that both employers and employees meet visa, work permit, and other legal standards.</p>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="corevaluesCard">
                                    <div className="categoryIcon"><img src={Core6} alt="icon" /></div>
                                    <h4>Professionalism</h4>
                                    <p>Demonstrate high standards of service, efficiency, and reliability in all recruiting and placement processes.</p>
                                </div>
                            </div> */}

                        </div>
                    </div>
                </section>

                {/* <section className="ourTeam-area common-padd-xl">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 text-center">
                                <h2>Our Leadership <span>Team</span></h2>
                                <div className="sliderTeam mt-5">
                                    <Swiper
                                        modules={[Navigation, Pagination, Scrollbar, A11y]}
                                        spaceBetween={10}
                                        slidesPerView={4}
                                        //navigation
                                        pagination={{ clickable: true }}
                                    //scrollbar={{ draggable: true }}
                                    >
                                        <SwiperSlide className="teamHolder">
                                            <div className="teamprofile"><img src={Team1} alt="team image" /></div>
                                            <h3>Kadir Miye</h3>
                                            <p><a href="#">miye@example.com</a></p>
                                            <hr />
                                            <ul className="socialmedia">
                                                <li><a href="#"><FaXTwitter /></a></li>
                                                <li><a href="#"><FaLinkedin /></a></li>
                                            </ul>
                                        </SwiperSlide>
                                        <SwiperSlide className="teamHolder">
                                            <div className="teamprofile"><img src={Team2} alt="team image" /></div>
                                            <h3>Zainab Rahman</h3>
                                            <p><a href="#">miye@example.com</a></p>
                                            <hr />
                                            <ul className="socialmedia">
                                                <li><a href="#"><FaXTwitter /></a></li>
                                                <li><a href="#"><FaLinkedin /></a></li>
                                            </ul>
                                        </SwiperSlide>
                                        <SwiperSlide className="teamHolder">
                                            <div className="teamprofile"><img src={Team3} alt="team image" /></div>
                                            <h3>Aiden Davis</h3>
                                            <p><a href="#">miye@example.com</a></p>
                                            <hr />
                                            <ul className="socialmedia">
                                                <li><a href="#"><FaXTwitter /></a></li>
                                                <li><a href="#"><FaLinkedin /></a></li>
                                            </ul>
                                        </SwiperSlide>
                                        <SwiperSlide className="teamHolder">
                                            <div className="teamprofile"><img src={Team4} alt="team image" /></div>
                                            <h3>Isabella Thompson</h3>
                                            <p><a href="#">miye@example.com</a></p>
                                            <hr />
                                            <ul className="socialmedia">
                                                <li><a href="#"><FaXTwitter /></a></li>
                                                <li><a href="#"><FaLinkedin /></a></li>
                                            </ul>
                                        </SwiperSlide>
                                        <SwiperSlide className="teamHolder">
                                            <div className="teamprofile"><img src={Team1} alt="team image" /></div>
                                            <h3>Kadir Miye</h3>
                                            <p><a href="#">miye@example.com</a></p>
                                            <hr />
                                            <ul className="socialmedia">
                                                <li><a href="#"><FaXTwitter /></a></li>
                                                <li><a href="#"><FaLinkedin /></a></li>
                                            </ul>
                                        </SwiperSlide>
                                    </Swiper>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="brandlogo-area common-padd-xl">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 brandlogo-title text-center mb-5">
                                <h2>We Deliver Measurable Results!</h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-3 grothResults">
                                <h2>95%</h2>
                                <p>Success Rate</p>
                            </div>
                            <div className="col-lg-3 grothResults">
                                <h2>200+</h2>
                                <p>Happy Clients</p>
                            </div>
                            <div className="col-lg-3 grothResults">
                                <h2>11,000+</h2>
                                <p>Placements</p>
                            </div>
                            <div className="col-lg-3 grothResults">
                                <h2>4.2</h2>
                                <p>Google Reviews</p>
                            </div>
                        </div>
                    </div>
                </section>*/}

                <section className="aboutpagetop-area position-relative common-padd-xl">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="aboutpagetop2-info">
                                    {responseData[6]?.type === "text" && responseData[6]?.content && (
                                        <h2>{sanitizeData(responseData[6]?.content)}</h2>
                                    )}
                                    {responseData[7]?.type === "editor" && responseData[7]?.content && (
                                        sanitizeData(responseData[7]?.content)
                                    )}
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="bundleImg-holder">
                                    <div className="row align-items-end mb-4">
                                        <div className="col-lg-6">
                                            {responseData[8]?.type === "image" && responseData[8]?.content && (
                                                <div className="galleryImg2">
                                                    <img src={responseData[8]?.content} alt="img 7" />
                                                </div>
                                            )}
                                        </div>
                                        <div className="col-lg-6">
                                            {responseData[9]?.type === "image" && responseData[9]?.content && (
                                                <div className="galleryImg1">
                                                    <img src={responseData[9]?.content} alt="img 8" />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12">
                                            {responseData[10]?.type === "image" && responseData[10]?.content && (
                                                <div className="galleryImg3">
                                                    <img src={responseData[10]?.content} alt="img 9" />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}
export default AboutScreen;